import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

class PrivacyPolicy extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    let body = document.body;
    body.className = 'privacy-policy';
  }

  render() {
    return (
      <Fragment>
        {' '}
        <div className="main-content yss-site--main__content Bullets">
          <div className="main-site__content">
            <div className="page__content">
              <div className="section--wrapper">
                <div className="section--width">
                  <div className="information_block block--para--lists">
                    <div className="block--title">
                      <h2>Privacy Policy</h2>
                    </div>
                    <p>
                      Coacherly (a platform owned and provided by Connecticut
                      Community for Addiction Recovery “CCAR”) is committed to
                      protecting and respecting the security and integrity of
                      your personal data.
                    </p>
                    <p>
                      CCAR understands that the privacy of user data is critical
                      to the trust necessary in the Coacherly platform. Because
                      of that, Coacherly only collects the minimum amount of
                      Personal Data necessary to provide services and does not
                      sell or share that data.{' '}
                    </p>
                    <p>
                      This Privacy Policy covers data collection and use through
                      the Coacherly platform. It outlines what data Coacherly
                      processes, why we process that data, and for how long that
                      data is maintained. It also provides information on rights
                      you may have regarding your personal data, and how to
                      exercise those rights.{' '}
                    </p>

                    <div className="block--title">
                      <h2>Table of Contents</h2>
                    </div>
                    <ul>
                      <li>Our Relationship With You</li>
                      <li>Information We Process</li>
                      <li>How We Use Your Information</li>
                      <li>How We Disclose Your Information</li>
                      <li>
                        Protection, Storage, and Retention of Your Information
                      </li>
                      <li>Other Important Information</li>
                      <li>Your Privacy Rights</li>
                      <li>Changes To Our Privacy Policy</li>
                      <li>Contact Us and Privacy Questions</li>
                    </ul>
                    <div className="block--title">
                      <h2>Our Relationship With You</h2>
                    </div>
                    <p>
                      CCAR is the controller (the entity that decides how and
                      why information is processed) of the information provided
                      to CCAR when you use the Coacherly platform.
                    </p>
                    <p>
                      The Coacherly platform is intended for adult (18+ years of
                      age) use only. The platform does not knowingly collect any
                      personal data from individuals under the age of 18.
                    </p>
                    <div className="block--title">
                      <h2>Information We Process</h2>
                    </div>
                    <p>
                      Coacherly processes information we receive directly from
                      you. The username and password you provide when creating a
                      profile is the only personal data the platform processes.
                    </p>
                    <div className="block--title">
                      <h2>Information Coacherly Receives Directly From You</h2>
                    </div>
                    <p>
                      Information needed to create an account. This includes
                      information that is needed for Coacherly to create an
                      account for you and manage your ability to log in and out
                      of Coacherly:
                    </p>
                    <ul>
                      <li>Your username</li>
                      <li>
                        Your password for the Coacherly platform – (hashed)
                      </li>
                    </ul>
                    <p>Coacherly may collect:</p>
                    <ul>
                      <li>
                        Profile photo and other information you provide to
                        describe yourself, which we only collect if you do
                        choose to provide it, such as your gender pronouns
                      </li>
                      <li>
                        Any other information you choose to provide while using
                        CCAR products and services that identifies or can be
                        reasonably associated with you
                      </li>
                    </ul>
                    <div className="block--title">
                      <h2>
                        Other information you may provide to us when you
                        interact with CCAR and in other ways
                      </h2>
                    </div>
                    <p>
                      You may voluntarily provide us with information when you
                      interact with us in other ways. If you directly interact
                      with CCAR Staff, CCAR may process:
                    </p>
                    <ul>
                      <li>
                        Your requests, questions, and responses to us via forms
                        or email
                      </li>
                      <li>
                        Information you provide in connection with contests, or
                        research studies, if you choose to participate
                      </li>
                      <li>Information to verify your identity</li>
                      <li>
                        Geographic information, such as region and country
                      </li>
                      <li>Social media information</li>
                      <li>Your date of birth</li>
                      <li>
                        Your audio and video, if you participate in a sales call
                        or user research study and do not opt out of call
                        recording, which also involves the collection of
                        biometric information associated with the call
                        recordings
                      </li>
                    </ul>
                    <div className="block--title">
                      <h2>Information CCAR Receives from Other Sources</h2>
                    </div>
                    <p>
                      CCAR receives a transaction ID associated with payments
                      made through our payment processor.
                    </p>
                    <div className="block--title">
                      <h2>How We Use Your Information</h2>
                    </div>
                    <p>
                      CCAR uses your information to operate our products and
                      services, communicate with you, process transactions when
                      you use our services, for security and fraud prevention,
                      and to comply with the law. Specifically, we may process
                      your information to:
                    </p>
                    <p>Provide services to you and operate our business</p>
                    <ul>
                      <li>
                        Maintain, provide, and improve our products and services
                      </li>
                      <li>Protect CCAR and you, for example:</li>
                      <ul>
                        <li>
                          Securing our systems and products against fraud or
                          unauthorised activity
                        </li>
                        <li>
                          Identifying, troubleshooting, and fixing bugs and
                          errors
                        </li>
                        <li>Complying with global laws and regulations</li>
                      </ul>
                    </ul>
                    <p>
                      In addition, we use information about your use of CCAR
                      products, account information (such as your email address
                      and name), and information related to third-party
                      integrations to:
                    </p>
                    <ul>
                      <li> Process your information at your direction</li>
                    </ul>
                    <p>Provide you with support and get your feedback</p>
                    <ul>
                      <li>Respond to your requests for information</li>
                      <li>
                        Help identify and troubleshoot any issues with your
                        account and answer your questions
                      </li>
                      <li>Resolve support requests</li>
                      <li>Provide you with reports about usage</li>
                      <li>
                        Survey your opinions through surveys, research studies,
                        and questionnaires
                      </li>
                    </ul>
                    <div className="block--title">
                      <h2>How We Disclose Your Information</h2>
                    </div>
                    <p>
                      We may need to disclose the information we collect about
                      you under the following conditions:
                    </p>
                    <ul>
                      <li>
                        To ensure the secure storage of your information. We use
                        trusted storage providers who are carefully vetted and
                        contractually bound to safeguard your data.
                      </li>
                      <li>
                        Because you ask us to disclose. We may disclose your
                        information to third parties when you ask us to do so.
                      </li>
                      <li>
                        Business transfers. If the ownership of all or
                        substantially all of our business changes, or all or
                        some of our assets are sold as part of a bankruptcy or
                        other proceeding, we may transfer your information to
                        the new owner so that the services can continue to
                        operate. In such case, your information would remain
                        subject to the promises and commitments contained in
                        this Privacy Policy until the acquiring party updates
                        it. If such transfer is subject to additional mandatory
                        restrictions under applicable laws or agreements, CCAR
                        will comply with those restrictions.
                      </li>
                      <li>
                        Compliance with legal obligations. To comply in good
                        faith with a valid legal request, or other lawful
                        process. We will notify individuals or customers of that
                        request unless: we are prohibited from doing so by law
                        or court order; or there are exceptional circumstances,
                        such as an emergency involving the risk of bodily injury
                        or death to a person or group of people or potential
                        harm to minors.
                      </li>
                    </ul>
                    <p>
                      We use and disclose the categories of information we
                      collect from and about you consistent with the various
                      business purposes we discuss throughout this Privacy
                      Statement. We do not disclose your information to third
                      parties for their own direct marketing purposes.
                    </p>

                    <div className="block--title">
                      <h2>
                        Protection, Storage, & Retention of Your Information
                      </h2>
                    </div>
                    <p>Security</p>
                    <p>
                      CCAR takes technical and organizational measures to
                      protect your information against accidental or unlawful
                      destruction or accidental loss, alteration, unauthorised
                      disclosure or access. However, no method of transmission
                      over the Internet and no means of electronic or physical
                      storage is absolutely secure, so we cannot ensure or
                      warrant the security of that information. We follow
                      industry standards when protecting your personal data.
                    </p>
                    <p>Storage</p>
                    <p>
                      Where we store your personal data: The data that we
                      collect from you may be transferred to, and stored at, a
                      destination outside the European Economic Area (“EEA”). By
                      submitting your personal data, you agree to this transfer,
                      storing or processing. We will take all steps reasonably
                      necessary to ensure that your data is treated securely and
                      in accordance with this privacy policy.
                    </p>
                    <p>Data Retention</p>
                    <p>
                      We will retain your information for the period necessary
                      to fulfil the purposes outlined in this Privacy Policy to
                      make our products and services available to you, or as
                      instructed by you, unless a longer retention period is
                      required or permitted by law.
                    </p>
                    <div className="block--title">
                      <h2>Other Important Information</h2>
                    </div>
                    <p>Marketing Practices and Choices</p>
                    <p>
                      If you receive email from us, we may use certain analytics
                      tools, such as clear GIFs, to capture data, such as when
                      you open our message or click on any links or banners
                      within our emails. This data allows us to gauge the
                      effectiveness of our communications and marketing
                      campaigns.
                    </p>
                    <p>
                      You may instruct us not to use your contact information to
                      contact you by email, postal mail, or phone regarding
                      products, services, promotions, and special events that
                      might appeal to your interests by contacting us at
                      coacherly@ccar.us. In commercial email messages, you can
                      also opt out by following the instructions located at the
                      bottom of such emails.
                    </p>
                    <p>
                      Please note that, regardless of your request, we may still
                      use and disclose certain information as permitted by this
                      Privacy Policy or as required by applicable law. For
                      example, you may not opt out of certain transactional,
                      operational, or service-related emails, such as those
                      reflecting our relationship or transactions with you.
                    </p>
                    <p>Legal Bases for Processing Your Information</p>
                    <p>
                      The laws in some jurisdictions require us to inform you of
                      our legal bases for processing your information. Our legal
                      bases for collecting and using your information described
                      above will depend on the particular type of information
                      and the specific context in which we collect it. However,
                      some examples of legal bases for processing that we rely
                      on:
                    </p>
                    <ul>
                      <li>
                        Where use of your information is necessary to perform
                        our obligations under a contract with you
                      </li>
                      <li>
                        Where use of your information is necessary for our
                        legitimate interests or the legitimate interests of
                        others (for example, to provide security, operate our
                        products and services, prevent fraud, analyse use of and
                        improve our products and services, and for similar
                        purposes)
                      </li>
                      <li>
                        Where use of your information is necessary to comply
                        with a legal obligation (for example, to comply with our
                        legal obligations to collect and store tax or invoice
                        information for a certain period of time)
                      </li>
                      <li>
                        Where we have your consent to process data in a certain
                        way
                      </li>
                    </ul>
                    <div className="block--title">
                      <h2>Your Privacy Rights</h2>
                    </div>
                    <p>Information about your rights</p>
                    <p>
                      Upon your request, and subject to applicable legal
                      exceptions, we will:
                    </p>
                    <ul>
                      <li>
                        provide access to and/or a copy of certain information
                        we hold about you
                      </li>
                      <li>
                        provide you with information about categories of
                        information we collect or disclose about you, the
                        categories of sources of such information, the business
                        or commercial purpose for collecting your information,
                        and the categories of third parties to which we disclose
                        your information. For your convenience and so you don’t
                        have to request it, we’ve included that information in
                        this Privacy Policy.• Provide you with information about
                        categories of information we collect or disclose about
                        you, the categories of sources of such information, the
                        business or commercial purpose for collecting your
                        information, and the categories of third parties to
                        which we disclose your information. For your convenience
                        and so you don’t have to request it, we’ve included that
                        information in this Privacy Policy.
                      </li>
                      <li>
                        Update information which is out of date or incorrect
                      </li>
                      <li>
                        Delete certain information which we have about you
                      </li>
                      <li>
                        Restrict the way that we process and disclose some of
                        your information
                      </li>
                      <li>
                        Transfer your information to a third-party provider of
                        services
                      </li>
                      <li>
                        Revoke your consent for the processing of your
                        information
                      </li>
                    </ul>
                    <p>
                      You have a right to lodge a complaint with CCAR, State
                      Attorneys General, or with ICO (The Information
                      Commissioner’s Office) directly, should you have a concern
                      about our information rights practices.
                    </p>
                    <p>
                      If you request these rights, we will need to verify your
                      identity and may need to verify your relationship with
                      CCAR for security and to prevent fraud.
                    </p>
                    <p>
                      Please note that certain information may be exempt from
                      such requests in some circumstances (for example, if we
                      need to keep processing your information for our
                      legitimate interests or to comply with a legal
                      obligation). Depending on applicable law, you may have the
                      right to appeal our decision to deny your request. If we
                      deny your request, we will provide you with information on
                      how to appeal the decision, if applicable, in our
                      communications with you.
                    </p>
                    <p>In the case of a data breach:</p>
                    <p>
                      The client will be informed consistent with applicable
                      law. We will do what we can to recover data and we will
                      take steps to prevent similar breaches from happening
                      again.
                    </p>
                    <div className="block--title">
                      <h2>Changes To Our Privacy Policy</h2>
                    </div>
                    <p>
                      We will update this Privacy Policy to make sure it
                      accurately reflects our data collection and use practices,
                      our amazing features, advances in technology, or as
                      applicable laws require. We will comply with applicable
                      legal requirements regarding providing you with notice
                      and/or consent when we make such changes, depending on the
                      type of change made. We also provide information about how
                      our Privacy Policy has changed over time below.
                    </p>
                    <div className="block--title">
                      <h2>Contact Us and Privacy Questions</h2>
                    </div>
                    <p>
                      Connecticut Community for Addition Recovery is a
                      non-profit organization located at 75 Charter Oak Ave,
                      Building 1, Suite 305, Hartford Connecticut (USA), 06106{' '}
                      <br />
                      If you wish to contact us or if you have any questions
                      about or complaints in relation to this notice, please
                      contact us at coacherly@ccar.us.
                    </p>
                    <p>This policy was last updated on 6/25/2024</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/components/PrivacyPolicy/PrivacyPolicy.js